module.exports = __webpack_public_path__ + "assets/icon_briefcase-medical.3f43c323.svg";